import storage from '../helpers/storage';

const key = 'CustomDimension';

let customDimensionObject = {};

function setDimension(prop, value) {
    if (!customDimensionObject) customDimensionObject = {};
    customDimensionObject[prop] = value;
    return customDimensionObject;
}

module.exports = {
    get: function () {
        customDimensionObject = storage.get(key);
        return customDimensionObject;
    },
    clear: function () {
        customDimensionObject = {};
        storage.remove(key);
    },
    set: function (prop, value) {
        setDimension(prop, value);
    },
    save: function () {
        storage.set(key, customDimensionObject);
    },
    exist: function () {
        return this.get() !== null;
    },

    setSuscriptorType: function (value) {
        setDimension('suscriptorType', value);
    },
    setRegistrado: function (value) {
        setDimension('usuarioRegistrado', value);
    },
    setUserId: function (value) {
        setDimension('userId', value);
    }
}


// WEBPACK FOOTER //
// ./~/@ln/registracionlibs/src/core/dimensions.js